module.exports = __webpack_public_path__ + "static/media/bg18.18f449c7.jpg";